enum ExtractType {
  PEOPLE = 'people',
  TOPIC = 'topic',
  SPONSOR = 'sponsor',
}

export default ExtractType;
